module.exports = __webpack_public_path__ + "static/media/Diagnostic-Intro.0a9a1bbc.mp3";